import React from 'react';
import { Crown, ShieldCheck, UserCheck, Eye } from 'lucide-react';

const CONFIG = {
  owner:   { label: 'Owner',   icon: Crown,       color: '#ffcf52', bg: 'rgba(255,207,82,0.12)', border: 'rgba(255,207,82,0.45)' },
  admin:   { label: 'Admin',   icon: ShieldCheck, color: '#c2d1e0', bg: 'rgba(194,209,224,0.1)', border: 'rgba(194,209,224,0.35)' },
  creator: { label: 'Creator', icon: UserCheck,   color: '#22d3ee', bg: 'rgba(34,211,238,0.1)',  border: 'rgba(34,211,238,0.35)' },
  viewer:  { label: 'Viewer',  icon: Eye,         color: '#a0a0a8', bg: 'rgba(255,255,255,0.05)', border: 'rgba(255,255,255,0.12)' },
};

export default function RoleBadge({ role, size = 'md', className = '' }) {
  const c = CONFIG[role] || CONFIG.viewer;
  const Ic = c.icon;
  const sizes = size === 'sm'
    ? 'text-[10.5px] px-1.5 py-0.5 gap-1'
    : 'text-[11px] px-2 py-0.5 gap-1';
  const iconSize = size === 'sm' ? 'w-3 h-3' : 'w-3.5 h-3.5';
  return (
    <span
      className={`inline-flex items-center rounded-full font-bold uppercase tracking-wider border ${sizes} ${className}`}
      style={{ color: c.color, background: c.bg, borderColor: c.border }}
    >
      <Ic className={iconSize} />
      {c.label}
    </span>
  );
}
